import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { getCourseEnrollUrl } from "../utils/constants";

const BlogDetail = () => {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);

  useEffect(() => {
    fetch("/data/blogs.json")
      .then((res) => res.json())
      .then((data) => {
        const foundBlog = data.find((b) => b.slug === slug);
        setBlog(foundBlog);
      })
      .catch((err) => console.error("Error loading blog:", err));
  }, [slug]);

  if (!blog)
    return (
      <div className="min-h-screen flex items-center justify-center text-gray-600">
        Blog not found 😕
      </div>
    );

  return (
    <article className="bg-gray-50 min-h-screen pb-20">
      {/* Hero Section */}
      <div className="relative h-72 md:h-96 w-full overflow-hidden">
        <img
          src={blog.headerImage}
          alt={blog.title}
          className="w-full h-full object-cover scale-100 hover:scale-105 transition duration-700"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
        <div className="absolute bottom-10 left-6 md:left-16 text-white">
          <h1 className="text-3xl md:text-5xl font-extrabold max-w-3xl drop-shadow-lg">
            {blog.title}
          </h1>
        </div>
      </div>

      {/* Content Section */}
      <div className="max-w-4xl mx-auto px-6 mt-12">
        <p className="text-gray-600 italic mb-8">{blog.metaDescription}</p>

        {blog.sections.map((section, i) => (
          <div
            key={i}
            className="mb-10 transition-transform duration-500 hover:translate-x-1"
          >
            <h2 className="text-2xl font-semibold text-indigo-700 mb-2">
              {section.heading}
            </h2>
            <p className="text-gray-700 leading-relaxed">{section.content}</p>
          </div>
        ))}

        {/* CTA Section */}
        <div className="mt-16 text-center bg-indigo-50 border border-indigo-100 p-10 rounded-2xl shadow-md hover:shadow-lg transition">
          <p className="text-lg font-semibold text-gray-800 mb-4">{blog.cta}</p>
          <button className="bg-green-500 hover:bg-green-600 text-white px-6 py-3 rounded-xl font-medium shadow-lg transition">
            <a
              href={getCourseEnrollUrl("Demo Session")}
              target="_blank"
              rel="noopener noreferrer"
            >
              Join Demo Class
            </a>
          </button>
        </div>
      </div>
    </article>
  );
};

export default BlogDetail;
